import { fetchPlatform } from '@/api/common';
export default {
  name: 'Login',
  created: function created() {
    var _this = this;
    if (!this.$route.query.token) {
      fetchPlatform().then(function (res) {
        location.href = "".concat(process.env.VUE_APP_PDS_URL, "/#/authorize?platform=") + res.platform + '&callback=' + (location.origin + '/#' + _this.$route.query.redirect);
      });
    }
  }
};